import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-16 px-6 md:px-12 max-w-3xl mx-auto" data-id="element-138">
      <FadeIn data-id="element-139">
        <div className="relative bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-blush" data-id="element-140">
          <Quote className="absolute top-6 left-6 w-10 h-10 text-blush opacity-50" data-id="element-141" />

          <div className="relative z-10 space-y-6 text-center" data-id="element-142">
            <p className="text-xl md:text-2xl font-serif italic text-warm-dark leading-relaxed" data-id="element-143">
              "¿Te despiertas a las 3 de la mañana empapada en sudor, sintiendo
              que tu propio cuerpo te ha traicionado? ¿Sientes que esa 'niebla
              mental' te hace olvidar palabras sencillas o te deja sin paciencia
              con quienes más amas?"
            </p>

            <div className="w-16 h-px bg-rose-gold mx-auto" data-id="element-144"></div>

            <p className="text-lg font-sans text-warm-dark/80" data-id="element-145">
              No estás perdiendo la cabeza. Tu cuerpo no está roto. Simplemente
              está intentando comunicarse contigo en un lenguaje que nadie te
              enseñó a descifrar.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}